import React from "react";
import { Box, Button, useMediaQuery, useTheme } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function SubmitButton({ onSubmit, isDemo }) {
  const { t } = useTranslation();
  const theme = useTheme();
  const navigate = useNavigate();
  const isExtraSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: isExtraSmallScreen ? "column" : "row",
        justifyContent: "center",
        alignItems: "center",
        gap: 2,
      }}
    >
      <Button
        onClick={() => navigate("/route")}
        sx={{
          fontWeight: 600,
          height: "55px",
          width: isExtraSmallScreen ? "100%" : "122px",
          textTransform: "none",
          borderRadius: "8px",
          fontSize: "20px",
          color: "#111214",
          backgroundColor: "#F2F2F3",
          border: "1px solid #414958",
          marginBottom: isExtraSmallScreen ? "10px" : 0,
        }}
      >
        {t("Cancel")}
      </Button>
      <Button
        onClick={onSubmit}
        sx={{
          fontWeight: 600,
          height: "55px",
          fontSize: "20px",
          color: "#111214",
          width: isExtraSmallScreen ? "100%" : "122px",
          textTransform: "none",
          borderRadius: "8px",
          backgroundColor: "#F9E719",
          border: "1px solid #414958",
          "&:hover": {
            backgroundColor: "#F5E016",
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
            transform: "translateY(-1px)",
            border: "1px solid #2C3441",
          },
        }}
      >
        {t("Save")}
      </Button>
    </Box>
  );
}